module.exports = __webpack_public_path__ + "static/bett1aces_ysl_003_mobile-24dcc1130e5a2be7eb150b40be640daf.gif";